import React, { useEffect, useState } from 'react';
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
  LineChart, Line, XAxis, YAxis, CartesianGrid,
} from 'recharts';
import { getAIUsage, AIUsageData } from '../../services/adminApi';

const COLORS = ['#3b82f6', '#8b5cf6', '#f59e0b', '#22c55e', '#ef4444', '#ec4899'];

export const AIUsagePanel: React.FC = () => {
  const [data, setData] = useState<AIUsageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getAIUsage()
      .then(setData)
      .catch(() => setError('Failed to load AI usage'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading AI usage...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data) return null;

  const pieData = data.by_feature.map((f) => ({
    name: f.feature_type,
    value: f.usage_count,
  }));

  return (
    <div className="admin-chart-container">
      <div className="admin-cards-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="admin-kpi-card">
          <div className="admin-kpi-value">{data.ai_adoption_pct}%</div>
          <div className="admin-kpi-label">Students Using AI</div>
        </div>
        <div className="admin-kpi-card">
          <div className="admin-kpi-value">{data.ai_user_count}</div>
          <div className="admin-kpi-label">AI Users (30d)</div>
        </div>
        <div className="admin-kpi-card">
          <div className="admin-kpi-value">{data.active_student_count}</div>
          <div className="admin-kpi-label">Active Students (30d)</div>
        </div>
      </div>

      <h3>Usage by Feature (30 days)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          >
            {pieData.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>

      <h3 style={{ marginTop: '2rem' }}>Daily AI Calls (30 days)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data.daily_trend}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} interval={4} />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="count" stroke="#8b5cf6" name="AI Calls" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
